// 首年梯度加费
export default {
  data() {
    return {
      list: [],
      load: false,
      conditionType: 1
    };
  },
  methods: {
    initData(init) {
      const planMap = {};
      this.tableItem.programBaseList.forEach(bean => {
        planMap[bean.id] = bean;
      });
      const close = this.$notice.loading();
      this.load = false;
      this.$http({
        url: '/buz/upcommission/queryConfigGradientCommission',
        type: 'POST',
        data: {
          productCode: this.topItem.productCode,
          isMain: this.tableItem.isMain,
          gradeCode: this.tableItem.gradeCode
        }
      })
        .then(res => {
          if (res.data && res.data.length) {
            res.data.forEach(item => {
              item.key = item.id;
              item.expenseStartTime = item.expenseStartTime || '';
              item.expenseEndTime = item.expenseEndTime || '';
              // 已过期
              if (item.expenseEndTime < this.$units.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')) {
                item.disabled = true;
              } else {
                item.disabled = false;
              }
              // 已开始
              if (item.expenseStartTime < this.$units.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')) {
                item.isSatrt = true;
              } else {
                item.isSatrt = false;
              }
              item.programIds = [];
              item.programNames = [];
              item.programList &&
                item.programList.forEach(item2 => {
                  item.programIds.push(item2.programId);
                  item.programNames.push(item2.programName);
                });
              item.gradientItemList = item.gradientConditionList;
              delete item.gradientConditionList;
              item.gradientItemList &&
                item.gradientItemList.forEach(item2 => {
                  item2.key = item2.id;
                  item.conditionType = item2.conditionType;
                  item2.programCommissionList = [];
                  if (item2.gradientGoalJoinList) {
                    item2.gradientGoalJoinList.forEach(item3 => {
                      item3.key = item3.id;
                      const item4 = item2.programCommissionList.find(p => p.commission == item3.commission);
                      if (item4) {
                        item4.programIds.push(item3.programId);
                        item4.programNames.push(planMap[item3.programId].name);
                      } else {
                        item2.programCommissionList.push({
                          programIds: [item3.programId],
                          programNames: [planMap[item3.programId].name],
                          commission: item3.commission
                        });
                      }
                    });
                    delete item2.gradientGoalJoinList;
                  } else {
                    this.addCommission(item2.programCommissionList);
                  }
                });
            });
            this.list = res.data;
          } else if (init) {
            this.list = [];
            this.add();
          } else {
            this.list = [];
          }
          if (this.over) {
            this.visible = true;
          }
        })
        .finally(() => {
          close();
          window.setTimeout(() => {
            this.load = true;
          }, 100);
        });
    },
  }
};
